import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function DateSection() {
  return (
    <section className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-xl px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-12 text-foreground-500">Reserva la fecha</p>
        </ScrollReveal>

        {/* Fine-line frame */}
        <ScrollReveal delay={1}>
          <div className="relative mx-auto max-w-sm px-8 py-12 sm:px-12 md:py-14">
            <span className="absolute inset-x-6 top-0 h-px bg-primary-300/60" />
            <span className="absolute inset-x-6 bottom-0 h-px bg-primary-300/60" />
            <span className="absolute inset-y-6 left-0 w-px bg-primary-300/60" />
            <span className="absolute inset-y-6 right-0 w-px bg-primary-300/60" />

            <div className="flex flex-col items-center gap-2">
              <span className="font-heading text-7xl font-light leading-none text-foreground-800 sm:text-8xl md:text-9xl">
                {weddingConfig.day}
              </span>
              <span className="font-heading text-3xl font-light italic leading-none tracking-wide text-primary-600 sm:text-4xl md:text-5xl">
                {weddingConfig.month}
              </span>
              <span className="mt-3 font-heading text-4xl font-light leading-none tracking-[0.3em] text-foreground-600 sm:text-5xl md:text-6xl">
                {weddingConfig.year}
              </span>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={2}>
          <div className="mt-10 flex items-center justify-center gap-3">
            <span className="h-px w-12 bg-primary-300" />
            <span className="h-1.5 w-1.5 rotate-45 bg-primary-400" />
            <span className="h-px w-12 bg-primary-300" />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}